$(document).ready(function() {

    var cookie = 'recently-viewed';

    var recentlyViewed = Cookies.get(cookie) ? JSON.parse(Cookies.get(cookie)) : [];
    var productsElement = $('.recently-viewed__products');

    // Remove product if it already exists and move to start of array
    recentlyViewed = recentlyViewed.filter(p => p.id !== product.id);
    recentlyViewed.unshift({
        id: product.id,
        title: product.title,
        handle: product.handle,
        price: product.price,
        compare_at_price: product.compare_at_price,
        featured_image: product.featured_image,
    });
    recentlyViewed = recentlyViewed.slice(0, 5);
    Cookies.set(cookie, JSON.stringify(recentlyViewed), { expires: 60 });

    var renderProducts = function() {
        var productsToDisplay = recentlyViewed.filter(p => p.id !== product.id).slice(0, 5);

        $('.recently-viewed').toggleClass('hidden', productsToDisplay.length === 0);
        $('.recently-viewed .card').addClass('hidden');

        productsToDisplay.forEach((product, index) => {
            var card = productsElement.find('a').eq(index);
            var photo = card.find('.card__photo');
            card.attr('href', '/products/' + product.handle);
            card.data('product-id', product.id);
            photo.attr('src', product.featured_image);
            photo.attr('alt', product.title);
            card.find('.card__meta-title').text(product.title);
            if(product.compare_at_price) {
                card.find('.card__meta-cta').text(Shopify.formatMoney(product.price, currencyFormat))
                .append($('<span>')
                .text(' was ')
                .append($('<del>')
                .text(Shopify.formatMoney(product.compare_at_price, currencyFormat))));
            } else {
                card.find('.card__meta-cta').text(Shopify.formatMoney(product.price, currencyFormat));
            }
            card.removeClass('hidden');
        });
    };

    $('.card__meta-close').bind('click', function(e){
        e.preventDefault();
        var card = $(this).closest('.card');
        var id = card.data('product-id');
        card.addClass('hidden');
        var updateRecentlyViewed = recentlyViewed.filter(p => p.id !== id);
        Cookies.set(cookie, JSON.stringify(updateRecentlyViewed), { expires: 60 });
        recentlyViewed = updateRecentlyViewed;
        renderProducts();
    });

    renderProducts();

});